<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        plain
        x-large
        v-bind="attrs"
        v-on="on"
        class="text-h6 px-0 fontDarkGrey--text"
      >
        {{ displayFirst | formatedPhone}}
      </v-btn>
    </template>
    <v-list :dense="true">
      <v-list-item
        v-for="(item, index) in user.main_cid_options"
        :key="index"
        class="px-0"
      >
        <v-list-item-action class="my-0">
          <PlainButton
            :buttonText="formated(item)"
            :method="'redirect'"
            @redirect="
              changeDid
                ? $emit('selectDid', item)
                : $router.push(`/user/${user.domain_user_id}/did/${item}`)
            "
          />
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PhoneNumberSelect",
  components: {
    PlainButton: () =>
      import("@/components/CommonComponents/Buttons/PlainButton"),
  },
  props: {
    changeDid: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayFirst: {
      type: String,
      required: true,
      default: "",
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.profile,
    }),
  },
  methods: {
    formated(stringNum) { 
        return this.$options.filters.formatedPhone(stringNum)
    },
  }
};
</script>
